import { PriorityEnum } from '@application/enums/priority-enum';
import { TaskCompletionStatusEnum } from '@application/enums/task-completion-status-enum';
import { alpha, useTheme } from '@mui/material';
const normalizePriority = (priority) => {
    if (typeof priority === 'number' && priority in PriorityEnum) {
        return priority;
    }
    if (typeof priority === 'string') {
        switch (priority.toLowerCase()) {
            case 'high':
                return PriorityEnum.High;
            case 'medium':
                return PriorityEnum.Medium;
            case 'low':
                return PriorityEnum.Low;
            case 'none':
                return PriorityEnum.None;
            default:
                return PriorityEnum.Medium;
        }
    }
    return PriorityEnum.Medium;
};
const useTaskCardStyles = (priority = PriorityEnum.Low, status = TaskCompletionStatusEnum.New, boxShadow = true, highlighted = false) => {
    const theme = useTheme();
    const resolvedPriority = normalizePriority(priority);
    const resolvedStatus = typeof status === 'string'
        ? (TaskCompletionStatusEnum[status] ??
            TaskCompletionStatusEnum.New)
        : status;
    // const priorityBarColors: Record<PriorityEnum, string> = {
    //   [PriorityEnum.Low]: theme.palette.common.black,
    //   [PriorityEnum.Medium]: theme.palette.primary.main,
    //   [PriorityEnum.High]: theme.palette.error.main,
    //   [PriorityEnum.None]: theme.palette.common.white
    //   // [PriorityEnum.Critical]: theme.palette.common.white,
    //   // [PriorityEnum.Trivial]: theme.palette.common.white
    // };
    const priorityChipColors = {
        [PriorityEnum.Low]: {
            backgroundColor: alpha(theme.palette.grey[500], 0.08),
            color: theme.palette.text.primary
        },
        [PriorityEnum.Medium]: {
            backgroundColor: alpha(theme.palette.warning.main, 0.16),
            color: theme.palette.warning.dark
        },
        [PriorityEnum.High]: {
            backgroundColor: alpha(theme.palette.success.main, 0.16),
            color: theme.palette.success.dark
        },
        [PriorityEnum.None]: {
            backgroundColor: theme.palette.grey[200],
            color: theme.palette.grey[800]
        }
    };
    return {
        taskCard: {
            borderRadius: (theme) => theme.spacing(3),
            py: (theme) => theme.spacing(2),
            px: (theme) => theme.spacing(2),
            backgroundColor: (theme) => theme.palette.background.paper,
            border: (theme) => highlighted
                ? `2px solid ${theme.palette.primary.main}`
                : `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
            width: '100%',
            position: 'relative',
            transition: 'all 0.3s ease-in-out',
            ...(highlighted && {
                transform: 'scale(1.02)'
            })
        },
        boxTop: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        boxBottom: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            mt: 1
        },
        boxItem: {
            display: 'flex',
            gap: 0.5,
            alignItems: 'center'
        },
        // colorBar: {
        //   backgroundColor: priorityBarColors[priority],
        //   position: 'absolute',
        //   left: '-2.5px',
        //   top: '50%',
        //   transform: 'translateY(-50%)',
        //   width: '5px',
        //   height: '42px',
        //   borderRadius: '10px'
        // } as SxProps<Theme>,
        assignedToDropdown: {
            mt: '7px',
            mb: '5px',
            flex: 1,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: (theme) => theme.palette.common.grey8,
            color: (theme) => theme.palette.grey[900],
            textTransform: 'none'
        },
        assignToDropdown: {
            mt: '7px',
            // mb: '5px',
            flex: 1,
            width: '100%'
        },
        collaboratorButton: {
            mt: '7px',
            // mb: '5px',
            minWidth: '44px',
            px: 1.5,
            py: 1,
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: (theme) => theme.palette.common.grey8,
            color: (theme) => theme.palette.grey[900],
            zIndex: 1000
        },
        taskHeading: {
            textDecorationLine: resolvedStatus === TaskCompletionStatusEnum.Completed ? 'line-through' : 'none',
            width: 'calc(100% - 40px)',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
        },
        priorityChip: {
            backgroundColor: priorityChipColors[resolvedPriority].backgroundColor,
            color: priorityChipColors[resolvedPriority].color,
            fontSize: '12px',
            fontWeight: 500
        },
        // iconButton: {
        //   position: 'absolute',
        //   top: 12,
        //   right: 16
        // } as SxProps<Theme>,
        bottomNewTaskDrawer: {
            p: 2,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
        }
    };
};
export default useTaskCardStyles;
